import axios from 'axios';

const PORT = window.location.port && window.location.port !== '80' ? ':' + process.env.REACT_APP_API_PORT : '';
const BASE_URL = window.location.protocol + '//' + window.location.hostname + PORT;
const MAX_SIZE = 2048; // Max Face++ image size is 4096 but image can have e.g. 1:2 aspect ratio

export const uploadImage = (file, galleryId) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException('Problem parsing input file.'));
    };
    reader.onload = () => {
      let imageData = reader.result;
      let img = document.createElement('img');
      let mimeType = imageData.split(',')[0].split(/[:;]/)[1];
      img.onload = () => {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        let width = img.width;
        let height = img.height;
        // Resize if image size exceeds max size
        if (width > MAX_SIZE || height > MAX_SIZE) {
          if (width > height) {
            height *= MAX_SIZE / width;
            width = MAX_SIZE;
          } else {
            width *= MAX_SIZE / height;
            height = MAX_SIZE;
          }
          canvas.width = width;
          canvas.height = height;
          ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          imageData = canvas.toDataURL(mimeType);
        }
        const form_data = new FormData();
        form_data.append('galleryId', galleryId);
        form_data.append('fileName', file.name);
        form_data.append('image', imageData.split(',')[1]);
        
        resolve(axios({
          method: 'post',
          url: `${BASE_URL}/upload`,
          headers: { 'Content-Type': 'multipart/form-data' },
          data: form_data,
        }));
      };
      img.src = imageData;
    };
    reader.readAsDataURL(file);
  });
};